import React from 'react';
import PropTypes from 'prop-types';
import { ExpandCollapse as ExpandCollapseBase, IconButton, useThemeTokensCallback } from '@telus-uds/components-base';
import styled from 'styled-components';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ExpandCollapseControl = /*#__PURE__*/styled.div.withConfig({
  displayName: "ExpandCollapse__ExpandCollapseControl",
  componentId: "components-web__sc-1l2mmq7-0"
})({
  alignItems: 'center',
  cursor: 'pointer',
  display: 'flex',
  flex: 1,
  justifyContent: 'flex-start'
});
const ExpandCollapseIconContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "ExpandCollapse__ExpandCollapseIconContainer",
  componentId: "components-web__sc-1l2mmq7-1"
})(_ref => {
  let {
    tokens
  } = _ref;
  return {
    alignItems: tokens.expandIconContainerAlignItems,
    justifyContent: tokens.expandIconContainerJustifyContent,
    marginLeft: `${tokens.expandIconContainerMarginY}px`,
    marginRight: `${tokens.expandIconContainerMarginY}px`,
    width: tokens.expandIconContainerWidth
  };
});
const ExpandCollapseTitle = /*#__PURE__*/styled.h4.withConfig({
  displayName: "ExpandCollapse__ExpandCollapseTitle",
  componentId: "components-web__sc-1l2mmq7-2"
})(_ref2 => {
  let {
    tokens
  } = _ref2;
  return {
    color: tokens.expandTitleColor,
    fontFamily: `${tokens.expandTitleFontName}${tokens.expandTitleFontWeight}normal`,
    fontSize: tokens.expandTitleFontSize,
    lineHeight: tokens.expandTitleLineHeight,
    margin: `${tokens.expandTitleMarginX}px ${tokens.expandTitleMarginY}px`
  };
});
const getIconButtonTokens = _ref3 => {
  let {
    icon,
    iconBackgroundColor,
    iconBorderColor,
    iconColor,
    iconOuterBorderColor,
    iconOuterBorderGap,
    iconOuterBorderWidth
  } = _ref3;
  return {
    icon,
    backgroundColor: iconBackgroundColor,
    borderColor: iconBorderColor,
    iconColor,
    outerBorderColor: iconOuterBorderColor,
    outerBorderGap: iconOuterBorderGap,
    outerBorderWidth: iconOuterBorderWidth
  };
};
const ExpandCollapse = /*#__PURE__*/React.forwardRef((_ref4, ref) => {
  let {
    children,
    collapseTitle,
    expandTitle = collapseTitle,
    expandLabel,
    collapseLabel
  } = _ref4;
  const getTokens = useThemeTokensCallback('TermsAndConditions', {}, {});
  const {
    expandBaseBorderWidth,
    expandContentPaddingBottom,
    expandContentPaddingLeft,
    expandContentPaddingRight,
    expandContentPaddingTop,
    contentBorderColor,
    contentMarginBottom,
    headerBackgroundColor,
    expandTitlePaddingLeft,
    expandTitleBorder,
    expandTitleBorderColor,
    expandTitleUnderline
  } = getTokens();
  return /*#__PURE__*/_jsx(ExpandCollapseBase, {
    tokens: {
      borderWidth: expandBaseBorderWidth
    },
    children: expandProps => /*#__PURE__*/_jsx(ExpandCollapseBase.Panel, {
      ...expandProps,
      panelId: "ExpandCollapsePanel",
      controlTokens: {
        icon: null,
        backgroundColor: 'transparent',
        paddingLeft: expandTitlePaddingLeft,
        borderColor: expandTitleBorderColor,
        borderWidth: expandTitleBorder,
        textLine: expandTitleUnderline
      }
      // TODO refactor
      // eslint-disable-next-line react/no-unstable-nested-components
      ,
      control: pressableState => {
        const {
          expanded
        } = pressableState || {};
        const iconTokens = getIconButtonTokens(getTokens(pressableState || {}));
        const label = expanded ? collapseLabel : expandLabel;
        return /*#__PURE__*/_jsxs(ExpandCollapseControl, {
          ref: ref,
          children: [/*#__PURE__*/_jsx(ExpandCollapseIconContainer, {
            tokens: getTokens(),
            children: /*#__PURE__*/_jsx(IconButton, {
              variant: {
                size: 'small'
              },
              tokens: iconTokens,
              focusable: false,
              accessibilityLabel: label,
              accessibilityRole: "none"
            })
          }), /*#__PURE__*/_jsx(ExpandCollapseTitle, {
            tokens: getTokens(),
            children: expanded ? expandTitle : collapseTitle
          })]
        });
      },
      tokens: {
        contentPaddingBottom: expandContentPaddingBottom,
        contentPaddingLeft: expandContentPaddingLeft,
        contentPaddingRight: expandContentPaddingRight,
        contentPaddingTop: expandContentPaddingTop,
        contentPanelBackgroundColor: headerBackgroundColor,
        borderColor: contentBorderColor,
        marginBottom: contentMarginBottom
      },
      children: children
    })
  });
});
ExpandCollapse.displayName = 'ExpandCollapse';
ExpandCollapse.propTypes = {
  children: PropTypes.node.isRequired,
  collapseTitle: PropTypes.string.isRequired,
  expandTitle: PropTypes.string,
  collapseLabel: PropTypes.string,
  expandLabel: PropTypes.string
};
export default ExpandCollapse;